import { REACT_QUERY_KEYS } from '@/constants'

import { type FetchSitesByDcIdQuery } from './api'

export const sitesQueryKeys = {
  all: [REACT_QUERY_KEYS.SITES] as const,
  selectByDcId: (query: FetchSitesByDcIdQuery) =>
    [...sitesQueryKeys.all, 'selectByDcId', query] as const,
  detail: (tenantKey: string, siteId: number) =>
    [...sitesQueryKeys.all, 'detail', tenantKey, siteId] as const
}
